'use strict';

// These will self-invoke if required
import 'url-polyfill';
import 'url-search-params-polyfill';
import 'whatwg-fetch';
import 'promise-polyfill/src/polyfill';
import 'formdata-polyfill';

// our polyfills will self-invoke if required
import 'utils/polyfills';

// widgets will invoke themselves
// vue widgets?

// Slide Up, Slide Down
import 'dom-slider';

//import 'modules/spotlight';
import {init as toggle} from 'modules/toggle';
import {init as videoResize} from 'modules/video-resize';
import {init as tabbing} from 'modules/tabbing';
import {init as accordion} from 'modules/accordion';
import {init as messages} from 'modules/messages';
import {init as videoModal} from 'modules/video-modal';
import {init as linkableSelect} from 'modules/linkable-select';
// import {init as eventGallery} from 'modules/event-gallery';
// import {init as scrollTo} from 'modules/scroll-to';
import {init as scroller} from 'modules/scroller';
import {init as cartStatus} from 'modules/cart-status';
import {init as userStatus} from 'modules/user-status';
import {init as imageGallery} from 'modules/image-gallery';
import {init as socialPanelGrid} from 'modules/social-panel-grid';
import {init as socialPanelGallery} from 'modules/social-panel-gallery';
import {init as donate} from 'modules/donate';
import {init as globalNavigation} from 'modules/global-navigation';
import {init as globalNavigationDesktop} from 'modules/global-navigation-desktop';
import {init as youtube} from 'modules/youtube';
import {init as headerVideo} from 'modules/header-video';
import {init as membershipLevels} from 'modules/membership-levels';
import {init as scrollToTop} from 'modules/scroll-to-top';
import {init as dialog} from 'modules/dialog';
import {init as infiniteScroll} from 'modules/infinite-scroll';
import {init as globalHeader} from 'modules/global-header';
import {init as globalNavigationScroll} from 'modules/global-navigation-scroll';
import {init as eventHeaderScroll} from 'modules/event-header-scroll';
import {init as eventHeaderNav} from 'modules/event-header-nav';
import {init as cognitoForm} from 'modules/cognito-form';
import {init as categorySwitch} from 'modules/category-switch';
import {init as eventInlineSticky} from 'modules/event-inline-sticky';
import {init as review} from 'modules/review';
import {init as eventInstances} from 'modules/event-instances';
import {init as videoController} from 'modules/video-controller';
import {init as eventNav} from 'modules/event-nav';
import {init as datePicker} from 'modules/date-picker';
import {init as tooltip} from 'modules/tooltip';
import {init as youtubeThumbnail} from 'modules/youtube-thumbnail';
import {init as favoriteButton} from 'modules/favorite-button';
import {init as articleNav} from 'modules/article-nav';
import {init as subscriptionBar} from 'modules/subscription-bar';

//import {init as orchestraRoster} from 'modules/orchestra-roster';


// Vue widgets
import './widgets/bootstrap';

// To make sure the code is run AFTER VueJS is loaded
// Code in imported modules is run asynchronously so cannot control the order but will ALWAYS run before the file doing the import
function load () {
    toggle();
    favoriteButton();
    videoResize();
    tabbing();
    accordion();
    messages();
    videoModal();
    linkableSelect();
    // eventGallery();
    // scrollTo();
    scroller();
    imageGallery();
    socialPanelGrid();
    socialPanelGallery();
    donate();
    globalNavigation();
    globalNavigationDesktop();
    youtube();
    headerVideo();
    membershipLevels();
    scrollToTop();
    dialog();
    tooltip();
    cartStatus();
    infiniteScroll();
    globalHeader();
    globalNavigationScroll();
    eventHeaderScroll();
    eventHeaderNav();
    cognitoForm();
    categorySwitch();
    eventInlineSticky();
    review();
    eventNav();
    eventInstances();
    videoController();
    datePicker();
    youtubeThumbnail();
    //orchestraRoster();
    articleNav();
    subscriptionBar();

    // breaks patterns so will put to bottom for now
    userStatus();
}

if (document.readyState === 'complete') {
    // If the document is already loaded, run the load function immediately
    load();
} else {
    window.addEventListener('load', load);
}
